import * as React from 'react';
import { ProductDetailUsps } from './ProductDetailUsps.js';
import { useCmsData } from '../../../../context/CmsContext.js';

const ProductDetailUspsContainer = ({ layout  })=>{
    const { usps  } = useCmsData();
    if (!usps || !(usps === null || usps === void 0 ? void 0 : usps.length)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ProductDetailUsps, {
        items: usps,
        layout: layout
    });
};

export { ProductDetailUspsContainer };
//# sourceMappingURL=ProductDetailUspsContainer.js.map
